import { CardContent } from "./internal/CardContent.js";
import { HighlightedCard, IconInfo } from "@myphx-engineering/phx-design-system";
import { jsx } from "react/jsx-runtime";

//#region src/components/pharmacy-card/HighlightPharmacyCard.tsx
/**
* Displays the information of a featured of great value pharmacy option within a list of pharmacies that the user can choose to send their prescription.
*/
const HighlightPharmacyCard = ({ variant, header, title, description, pricing, value, subtitle, toggleFavorite, onIconClick, onClick, additionalInfo, footer, role, favorite }) => {
	return /* @__PURE__ */ jsx(HighlightedCard, {
		Icon: IconInfo,
		onIconClick,
		iconPosition: "right",
		header,
		color: variant === "Featured" ? "info" : "primary",
		onClick,
		role,
		children: /* @__PURE__ */ jsx(CardContent, {
			title,
			description,
			pricing,
			value,
			additionalInfo,
			subtitle,
			toggleFavorite,
			footer,
			favorite
		})
	});
};

//#endregion
export { HighlightPharmacyCard };